<div mat-dialog-title>
  <div class="dialog-header">
    <div class="title">C3 Stations</div>
    <div class="actions">
      <mat-icon svgIcon="close" class="action-icon" (click)="close()"></mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="stations-list-content">

    <!-- Title -->
    <div class="row">
      <div class="destinations">
        <div class="table-header name">Name</div>
        <div class="table-header station">Station</div>
      </div>
      @for (station of stations; track station.id) {
        <div class="destinations">
          <input class="input name" [(ngModel)]="station.stationName" (blur)="updateStation(station)" (keydown.enter)="updateStation(station)">
          <input class="input station" [(ngModel)]="station.stationId" (blur)="updateStation(station)" (keydown.enter)="updateStation(station)">
          @if (permissions | includesBy: 'project:update') {
            <div class="button-delete">
              <mat-icon svgIcon="trash" class="icon" (click)="deleteStation(station)"></mat-icon>
            </div>
          }
        </div>
      }
      <div class="destinations">
        <input class="input name" [(ngModel)]="stationName">
        <input class="input station" [(ngModel)]="stationId">
        <div class="button-delete" [class.disabled]="stationName.length === 0 || stationId.length === 0">
          <mat-icon svgIcon="plus" class="icon" (click)="createStation()"></mat-icon>
        </div>
      </div>
    </div>

  </div>
</div>